export default [
    {
      path: '/rent/v2/shop-map',
      name: 'shopMap',
      component: () => import('@/pages/shop/shopMap'),
      meta: { title: '门店地图', requireAuth: true },
    }
  ]


// WEBPACK FOOTER //
// ./src/pages/shop/shop.js